import { NAN_PARAMS, PARAMS_NAME } from "./config";
import { roundTo } from "../../Utils";

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Graph from './components/Graph';

import React from 'react';

import Table from '../../components/StatsTable';
import Form from './components/Form';

import API from '../../services/API';

import _ from 'lodash';

class BidderHourly extends React.Component {
    constructor() {
        super();

        this.state = {
            params: [],
            paramsObj: {},
            report: [],
            total: {},
            isLoading: false,
            availableSources: [],
            graph: []
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        API.BidderSources.getAvailableSources().then((sources) => {
            sources.push('DEFAULT');

            this.setState({ availableSources: sources });
        })

        const day = new Date().toISOString().split('T')[0];

        API.Bidder.getHourlyV2Graph({ day }).then(({ graph }) => this.setState({ graph }));
    }

    async handleSubmit(filters, checkboxes) {
        if (!filters.groupBy.length) return alert('Select at least one "Group By" param');

        this.setState({ isLoading: true });

        const promises = [
            API.Bidder.getHourlyV2(filters),
            API.Bidder.getHourlyV2Graph(filters)
        ];

        if (checkboxes.realtime && filters.day === new Date().toISOString().split('T')[0]) {
            promises.push(API.BidderRealtime.hourly.get({ groupBy: filters.groupBy, country: filters.country, source: filters.source }));
        }

        await Promise.all(promises).then(([ { total, params, report }, { graph }, realtime ]) => {
            if (realtime && realtime.report && realtime.report.length) {
                total = _.reduce([ total, realtime.total ], (x, y) => _.mergeWith(x, y, (x, y, param) => {
                    // TODO: Recalculate business params when realtime report shown, line below returns values w/o realtime
                    if ([ 'cpc', 'eCpm', 'ctr', 'winsPercent' ].includes(param)) return x;

                    return roundTo(4, Number(x) + Number(y))
                }));

                report = [ ...report, ...realtime.report ];

                graph = [ ...graph, { hour: `LIVE - ${new Date().getUTCHours()}`, ...realtime.total } ]
            }

            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});

            const newState = { params, paramsObj, report, total, graph, isLoading: false };

            this.setState(newState)
        })
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return ( <Graph data={graph}/> );
    }

    render() {
        const { isLoading, availableSources, params, paramsObj, report, total } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Hourly"/>

                <Form sources={availableSources} onSubmit={this.handleSubmit}/>

                {this.getGraph()}

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        );
    }
}

export default BidderHourly;



// WEBPACK FOOTER //
// ./src/scenes/BidderHourlyV2/index.js